// ---------------------------------------------------------------------------
// حديقة جدو يوسف in three.js. The tray shows an animal and its name is spoken;
// only the letters of that name float in the sky. Tap the next one and it names
// itself and flies into its slot; tap any other and it still names itself and
// shakes it off — there is no fail state, and no tap goes unanswered.
// A finished word puts the animal in the field for good, wandering with a brain
// of its own while Jiddo turns to it and welcomes it by name.
//
// Everything that moves is driven by clips now. The animals came out of a
// bought pack rigged for clips and nothing else (animals.ts); Jiddo's second
// model came with six of its own — a walk and a run, a wave, a talk, a
// startled turn and an idle — and what he is doing decides which one plays
// (jiddo.ts). The rabbit's hops are the one motion no clip can carry
// (brains.ts). README.md has the rest, and a map of the modules.
//
// This is the entry point: the ?dbg handle and the boot. The frame loop, the
// resize and the round are the engine's (core/), shared with tata/; everything
// else is imported.
// ---------------------------------------------------------------------------
import {loadModels,tpl} from './animals';
import {asset} from '../../core/assets';
import {setVoice} from '../../core/audio';
import {ANIMALS,DIA,INTRO,NAMES,REACT} from './data';
import {drinkSpot} from './brains';
import {animals,fieldSpot,jiddo,jiddoBody,updateField} from './field';
import {jiddoDebug,loadJiddo,noticeNow,updateJiddo,waveNow} from './jiddo';
import {exposeDebug,startLoop} from '../../core/loop';
import {footprint} from '../../core/body';
import './set';                                // his pond, his trees, his house
import './round';                              // his round: the engine's, told who lives in the field
import {spawn} from '../../core/round';
import {T,follow,placeCam,view} from '../../core/scene';
import {setTray} from '../../core/tray';
import {setVowelled} from '../../core/letters';
import {bank,crossesWater,pondR} from '../../core/water';

// His part of the ?dbg handle (exposeDebug, core/loop.ts): the animals and an
// animal straight into the field, the pond's arithmetic, and Jiddo himself.
exposeDebug({get animals(){return animals},roster:ANIMALS.map(a=>a.w),get pose(){return jiddoDebug.clip},
  get jState(){return jiddoDebug.jState},get jModel(){return jiddoDebug.jModel},get jTurn(){return jiddoDebug.turn},get jStrides(){return jiddoDebug.strides},get tpl(){return tpl},get jPad(){return jiddoBody.pad},
  pondR,crossesWater,bank,drinkSpot,fieldSpot,footprint,
  jiddo,spawn:(w?:string)=>spawn(w||'فيل',performance.now()),
  notice:(i?:number)=>{noticeNow(animals[i||0],performance.now());},wave:waveNow,
  get jPhase(){return jiddoDebug.jPhase},set jPhase(v:number){jiddoDebug.jPhase=v;}});

// ---- boot ----
// What there is to say, and the order to ask for it in. His hello comes first
// because the first round's letters wait on it (announceRound, round.ts); a
// manifest that asks for it late opens the game in silence.
const want:[string,string][]=[['R',INTRO]];
for(const k of Object.keys(NAMES))want.push(['L',k]);
for(const a of ANIMALS)want.push(['W',a.w]);
for(const a of ANIMALS)want.push(['S',a.w]);                        // his own noise; a 404 here is fine
for(const c of REACT.flatMap(b=>b.clips))want.push(['R',c]);
for(const a of ANIMALS){want.push(['R','ترحيب-'+a.w]);want.push(['R','دهشة-'+a.w]);}   // his lines for this one; a 404 here is fine
setVoice({say:NAMES,dia:DIA,want});
setVowelled(DIA);                              // each letter shown with its حركة, in the tray and the sky
setTray({pic:w=>asset('img/a_'+encodeURIComponent(w)+'.webp')});   // the art set is named for the animals

loadJiddo(); loadModels();
T.set(jiddo.position.x,T.y,jiddo.position.z);    // on him from the first frame, not panning over
startLoop((t,dt)=>{
  follow(jiddo.position.x,jiddo.position.z,dt);  // the camera goes where he goes
  placeCam(view.yaw,view.el);
  updateJiddo(t,dt);
  updateField(t,dt);
},()=>animals.length+' 🐾');
